import { Injectable } from "@angular/core";

import { BehaviorSubject } from "rxjs";

import { SelectedOption } from "../model/selected-option";

@Injectable()
export class AddCustomOptionService {
    showAddCustomOption$: BehaviorSubject<boolean> = new BehaviorSubject(false);
    customOptions$: BehaviorSubject<Array<SelectedOption>> = new BehaviorSubject([]);
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/services/add-custom-option.service.ts